import React, { ReactNode } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { theme, colors } from '@picardy/picardy-design-system';

export interface Props {
  title?: string;
  children?: ReactNode;
  variant?: 'gray' | 'green';
}

export function SectionHeaderBarTitle({ children }: { children?: ReactNode }) {
  return (
    <Typography
      style={{
        color: theme.palette.grey['100'],
        textTransform: 'uppercase',
      }}
      variant="h6"
    >
      {children}
    </Typography>
  );
}

export default React.forwardRef(function SectionHeaderBar(
  { title, children, variant = 'gray' }: Props,
  ref,
) {
  return (
    <Box
      component={props => <div {...props} ref={ref} />}
      display="flex"
      flexDirection="row"
      marginBottom={2}
      paddingLeft={2}
      paddingRight={2}
      paddingTop={1}
      paddingBottom={1}
      justifyContent="space-between"
      alignItems="center"
      style={{
        backgroundColor: {
          gray: colors.picardyGray,
          green: colors.picardyChalkboardGreen,
        }[variant],
        borderRadius: '0.25em',
        width: '100%',
      }}
    >
      {title && <SectionHeaderBarTitle>{title}</SectionHeaderBarTitle>}
      {children}
    </Box>
  );
});
